import React from 'react';
import styles from './trialOffer.module.css';

const TrialOffer: React.FC = () => {
  return (
    <div className={styles.trialSection}>
      <div className={styles.trialOffer}>
        <span className={styles.trialDays}>Watch Vertical TV</span>
        
        {/* <span className={styles.trialText}>trial</span> */}
      </div>
      <div className={styles.trialDetails}>
      <button className={styles.freeBadge}>FREE</button>
        {/* <span className={styles.trialPrice}>₹2 to start trial.</span>
        <span className={styles.trialRefund}>Refunded instantly</span> */}
      </div>
    </div>
  );
};

export default TrialOffer;


